"use client";

import { MainContent } from "@/components";
import { FilterMenu } from "@/components/core/FilterMenu";
import { MobileFilterMenu } from "@/components/core/MobileFilterMenu";
import { type FilterConfig, useFilter } from "@/context/FilterProvider";
import { Box, Stack } from "@biom3/react";
import { SliceContext } from "@cms/context";
import { components } from "@cms/slices";
import type { Content } from "@prismicio/client";
import { SliceZone } from "@prismicio/react";
import { useIsLessThanLargeScreen } from "@ui-kit/hooks/screenSizeHooks";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

interface GamesListProps {
  page: Content.GamesPageDocument;
  filtersConfig: Record<string, FilterConfig>;
  gameCollections: Record<string, Content.GameDocument[]>;
}

function GamesListContent({
  page,
  filtersConfig,
  gameCollections,
}: GamesListProps) {
  const { t } = useTranslation();
  const { setFilterConfig } = useFilter();
  const lessThanMediumScreen = useIsLessThanLargeScreen();

  useEffect(() => {
    setFilterConfig(filtersConfig);
  }, [filtersConfig, setFilterConfig]);

  return (
    <Stack
      direction="row"
      sx={{ pos: "relative", p: "base.spacing.x6" }}
      testId="GamesListPage__mainContainer"
    >
      {!lessThanMediumScreen && <FilterMenu />}
      <Box sx={{ flex: 1 }}>
        {lessThanMediumScreen && <MobileFilterMenu />}
        <SliceContext.Provider
          value={{
            t,
            wishlistProps: {
              gemsState: "disabled",
              isWishlisted: false,
              onWishlistClick: () => Promise.resolve(),
            },
            data: { gameCollections },
          }}
        >
          <SliceZone components={components} slices={page?.data?.slices} />
        </SliceContext.Provider>
      </Box>
    </Stack>
  );
}

export default function GamesList(props: GamesListProps) {
  return (
    <MainContent>
      <GamesListContent {...props} />
    </MainContent>
  );
}
